var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from 'vue-property-decorator';
import dayjs from 'dayjs';
var VersionAuthHintModal = /** @class */ (function (_super) {
    __extends(VersionAuthHintModal, _super);
    function VersionAuthHintModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /* data */
        _this.timer = null; // 获取数据的定时器
        _this.HH = '';
        _this.MM = '';
        _this.DD = '';
        return _this;
    }
    Object.defineProperty(VersionAuthHintModal.prototype, "isBusiness", {
        get: function () {
            return this.data.versionType === 'REQUIREMENT';
        },
        enumerable: false,
        configurable: true
    });
    VersionAuthHintModal.prototype.confirm = function () {
        this.$emit('input', false);
        this.$emit('change', false);
    };
    VersionAuthHintModal.prototype.showDateText = function (val) {
        return val ? dayjs(val).format('YYYY.MM.DD') : '';
    };
    __decorate([
        Prop({
            type: Object,
            default: function () { },
        })
    ], VersionAuthHintModal.prototype, "data", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: false,
        })
    ], VersionAuthHintModal.prototype, "value", void 0);
    VersionAuthHintModal = __decorate([
        Component({
            components: {}
        })
    ], VersionAuthHintModal);
    return VersionAuthHintModal;
}(Vue));
export default VersionAuthHintModal;
